/* eslint-disable */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import firebase from "firebase";
import "./../node_modules/bulma/css/bulma.css";
// import Buefy from "buefy";
// import "buefy/lib/buefy.css";

// Vue.use(Buefy);

Vue.config.productionTip = false;

let app;

const config = {
  apiKey: "AIzaSyBer8w_0idFtT7bhCYpMMM_iXwMmLR7nTk",
  authDomain: "musikwellehelfer2019.firebaseapp.com",
  databaseURL: "https://musikwellehelfer2019.firebaseio.com",
  projectId: "musikwellehelfer2019",
  storageBucket: "musikwellehelfer2019.appspot.com",
  messagingSenderId: "379141696622",
  appId: "1:379141696622:web:ae70b4fe75ad417d"
};

const firebaseapp = firebase.initializeApp(config);

export default firebaseapp.firestore();

export const globalStore = new Vue({
  data: {
    globalAdmin: ["moeruw@gmail.com"]
  }
});

firebase.auth().onAuthStateChanged(function(user) {
  if (!app) {
    /* eslint-disable no-new */
    app = new Vue({
      el: "#app",
      template: "<App/>",
      components: { App },
      router
    });
  }
});
